import React, { useCallback, useEffect } from 'react';
import { useAuth0 } from '../../../lib/auth0-wrapper';

import EmailVerified from './email-verified';
import UserBlocked from './user-blocked';
import Unauthorized from './unauthorized';
import ServiceLocked from './service-locked';

function LoginFailed() {
    const { catchError } = useAuth0();

    const goHome = useCallback(() => {
        window.location.href = process.env.REACT_APP_PUBLIC_URL;
    }, []);

    const goActiveHome = useCallback(() => {
        window.location.href = process.env.REACT_APP_AUTH_LOGOUT_URL;
    }, []);

    useEffect(() => {
        if (catchError === false || catchError.code === 'invalid') {
            goHome();
        }
    }, [catchError]);

    if (catchError && catchError.details) {
        switch (catchError.details.reason) {
            case 'email-verified':
                return <EmailVerified goHome={goActiveHome} id={catchError.details.id} email={catchError.details.email} />
            case 'user-blocked':
                return <UserBlocked goHome={goActiveHome} />
            case 'service-locked':
                return <ServiceLocked goHome={goActiveHome} />
            default:
                return <Unauthorized goHome={goActiveHome} />
        }
    } else {
        return null; // This case is prevented with the useEffect above.
    }

}

export default LoginFailed;